/* eslint-disable prettier/prettier */
import { useState } from "react";

// react-router-dom components
import { Link, useNavigate } from "react-router-dom";
import axios from "axios";

// @mui material components
import Card from "@mui/material/Card";
import Switch from "@mui/material/Switch";
import Grid from "@mui/material/Grid";
import MuiLink from "@mui/material/Link";

// Material Dashboard 2 React components
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import MDInput from "components/MDInput";
import MDButton from "components/MDButton";

// Authentication layout components
import BasicLayout from "layouts/authentication/components/BasicLayout";

// Images
import bgImage from "assets/images/bg-sign-in-basic.jpeg";
import API_CONFIG from "../../../config";

function Basic() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [rememberMe, setRememberMe] = useState(false);
  const [errors, setErrors] = useState({ email: "", password: "" });
  const [serverError, setServerError] = useState("");

  const navigate = useNavigate();

  const handleSetRememberMe = () => setRememberMe(!rememberMe);

  const handleSubmit = async (e) => {
    e.preventDefault();

    // Reset errors
    setErrors({ email: "", password: "" });

    // Basic validation
    let formIsValid = true;
    let tempErrors = { email: "", password: "" };

    if (!email) {
      formIsValid = false;
      tempErrors.email = "Email is required.";
    }

    if (!password) {
      formIsValid = false;
      tempErrors.password = "Password is required.";
    }

    // If form is invalid, set errors and exit
    if (!formIsValid) {
      setErrors(tempErrors);
      return;
    }

    try {
      const response = await axios.post( API_CONFIG.BASE_URL+"home/user/login", {
        email,
        password,
      });

      if (response.data.token) {
        // Set role as Admin
        sessionStorage.setItem("role", "Admin");
        
        if (rememberMe) {
          localStorage.setItem("authToken", response.data.token);
          sessionStorage.setItem("token", response.data["token"]);
          localStorage.setItem("user", JSON.stringify({ 
            name: response.data.token,
            role: "Admin" // Add role information
          }));
        } else {
          sessionStorage.setItem("authToken", response.data.token);
          sessionStorage.setItem("token", response.data["token"]);
          localStorage.setItem("user", JSON.stringify({ 
            name: response.data.token,
            role: "Admin" // Add role information
          }));
        }
        navigate("/dashboard");
      } else {
        setServerError(response.data.message);
      }
    } catch (error) {
      console.error("Login error:", error);
      setServerError("Invalid credentials. Please try again.");
    }
  };

  return (
    <BasicLayout image={bgImage}>
      <Card>
        <MDBox
          variant="gradient"
          bgColor="info"
          borderRadius="lg"
          coloredShadow="info"
          mx={2}
          mt={-3}
          p={2}
          mb={1}
          textAlign="center"
        >
          <MDTypography variant="h4" fontWeight="medium" color="white" mt={1}>
            Sign in
          </MDTypography>
        </MDBox>
        <MDBox pt={4} pb={3} px={3}>
          <MDBox component="form" role="form" onSubmit={handleSubmit}>
            {/* Error Message */}
            {serverError && (
              <MDBox mb={2} color="error.main">
                <MDTypography variant="body2" color="error">{serverError}</MDTypography>
              </MDBox>
            )}
            <MDBox mb={2}>
              <MDInput
                type="email"
                label="Email"
                fullWidth
                variant="outlined"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                error={!!errors.email}
                helperText={errors.email && (
                  <MDTypography variant="body2" color="error">
                    {errors.email}
                  </MDTypography>
                )}
                InputLabelProps={{ shrink: true }}
              />
            </MDBox>
            <MDBox mb={2}>
              <MDInput
                type="password"
                label="Password"
                variant="outlined"
                fullWidth
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                error={!!errors.password}
                helperText={errors.password && (
                  <MDTypography variant="body2" color="error">
                    {errors.password}
                  </MDTypography>
                )}
                InputLabelProps={{ shrink: true }}
              />
            </MDBox>
            <MDBox display="flex" alignItems="center" ml={-1}>
              <Switch checked={rememberMe} onChange={handleSetRememberMe} />
              <MDTypography
                variant="button"
                fontWeight="regular"
                color="text"
                onClick={handleSetRememberMe}
                sx={{ cursor: "pointer", userSelect: "none", ml: -1 }}
              >
                &nbsp;&nbsp;Remember me
              </MDTypography>
            </MDBox>
            <MDBox mt={4} mb={1}>
              <MDButton variant="gradient" color="info" fullWidth type="submit">
                sign in
              </MDButton>
            </MDBox>
          </MDBox>
        </MDBox>
      </Card>
    </BasicLayout>
  );
}

export default Basic;
